import { CSSProperties } from "react";

type CustomTheme = {
    [key: string]: CSSProperties;
};

export const customCodeStyle: CustomTheme = {
    'code[class*="language-"]': {
        color: "currentColor",
        fontFamily: "Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace",
        direction: "ltr",
        textAlign: "left",
        whiteSpace: "pre",
        wordSpacing: "normal",
        wordBreak: "normal",
        lineHeight: "1.5",
        MozTabSize: "4",
        OTabSize: "4",
        tabSize: "4",
        WebkitHyphens: "none",
        MozHyphens: "none",
        msHyphens: "none",
        hyphens: "none"
    },
    'pre[class*="language-"]': {
        color: "currentColor",
        fontFamily: "Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace",
        direction: "ltr",
        textAlign: "left",
        whiteSpace: "pre",
        wordSpacing: "normal",
        wordBreak: "normal",
        lineHeight: "1.5",
        MozTabSize: "4",
        OTabSize: "4",
        tabSize: "4",
        WebkitHyphens: "none",
        MozHyphens: "none",
        msHyphens: "none",
        hyphens: "none",
        padding: "1em",
        overflow: "auto",
        borderRadius: ".5rem",
        background: "transparent"
    },
    ':not(pre) > code[class*="language-"]': {
        background: "transparent",
        padding: ".1em",
        borderRadius: ".5rem"
    },
    comment: {
        color: "#7C7C7C"
    },
    prolog: {
        color: "#7C7C7C"
    },
    doctype: {
        color: "#7C7C7C"
    },
    cdata: {
        color: "#7C7C7C"
    },
    punctuation: {
        color: "currentColor"
    },
    ".namespace": {
        opacity: ".7"
    },
    property: {
        color: "#5993eb"
    },
    keyword: {
        color: "#f55656"
    },
    tag: {
        color: "#5993eb"
    },
    "class-name": {
        color: "#5993eb"
    },
    boolean: {
        color: "#2ab587"
    },
    constant: {
        color: "#2ab587"
    },
    symbol: {
        color: "#f92672"
    },
    deleted: {
        color: "#f92672"
    },
    number: {
        color: "#FF73FD"
    },
    selector: {
        color: "#A8FF60"
    },
    "attr-name": {
        color: "#fc953a"
    },
    string: {
        color: "#2ab587"
    },
    char: {
        color: "#A8FF60"
    },
    builtin: {
        color: "#2ab587"
    },
    inserted: {
        color: "#A8FF60"
    },
    variable: {
        color: "#e29cff"
    },
    operator: {
        color: "currentColor"
    },
    entity: {
        color: "#FFFFB6",
        cursor: "help"
    },
    url: {
        color: "#5993eb"
    },
    ".language-css .token.string": {
        color: "#2ab587"
    },
    ".style .token.string": {
        color: "#2ab587"
    },
    atrule: {
        color: "#2ab587"
    },
    "attr-value": {
        color: "#2ab587"
    },
    function: {
        color: "#5993eb",
        fontWeight: "bold"
    },
    regex: {
        color: "#E9C062"
    },
    important: {
        color: "#fd971f",
        fontWeight: "bold"
    },
    bold: {
        fontWeight: "bold"
    },
    italic: {
        fontStyle: "italic"
    }
};
